"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMatchMedia = exports.matchMediaKey = void 0;
var vue_1 = require("vue");
var hasSymbol = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var PolySymbol = function (name) {
    return hasSymbol
        ? Symbol(name)
        : name;
};
exports.matchMediaKey = PolySymbol('mm');
function useMatchMedia() {
    return vue_1.inject(exports.matchMediaKey);
}
exports.useMatchMedia = useMatchMedia;
